import './styles.scss';

import React, { useCallback } from 'react';

import { useNavigate } from 'react-router';

import { Button } from '../../components/Button';
import { Container } from '../../components/Container';
import { KaiScore } from '../../components/KaiScore';
import { ResponsiveImage } from '../../components/ResponsiveImage';
import { VisibleOn } from '../../components/VisibleOn';
import { useStoreData, useStoryblokStrings } from '../../hooks';
import { classNames } from '../../services/classNames';
import { parseHTML } from '../../services/parseHTML';
import { Storyblok, StoryblokSection } from '../../storyblok';

export const GetScoreSection = ({
    sectionData,
}: StoryblokSection<Storyblok.Component.GetScoreSection>) => {
    const navigate = useNavigate();
    const paths = useStoryblokStrings('paths');
    const { scoreData } = useStoreData().user;

    const {
        background_image,
        get_score_button_link,
        get_score_button_title,
        get_score_description,
        get_score_title,
        tracking_event_action_name,
        component,
    } = sectionData;

    const buttonHandler = useCallback(() => {
        if (!scoreData) {
            navigate(get_score_button_link);
            return;
        }

        navigate(paths['check_score']);
    }, [scoreData, navigate]);

    return (
        <section
            className={classNames(
                'BankLoginSection',
                `BankLoginSection--get-score`,
            )}
            data-block={component}
        >
            <div className="GetScoreScene">
                {background_image && (
                    <VisibleOn tablet desktop>
                        <ResponsiveImage
                            image={background_image}
                            className="BankLoginScene__background"
                            objectFit
                        />
                    </VisibleOn>
                )}
                <Container className="GetScoreScene__wrapper">
                    <div className="GetScoreScene__content-wrapper">
                        {get_score_title && (
                            <h2 className="GetScoreScene__title">
                                {parseHTML(get_score_title)}
                            </h2>
                        )}

                        {tracking_event_action_name && (
                            <div className="GetScoreScene__kai-wrapper">
                                <button
                                    type="button"
                                    className="GetScoreScene__kai-link"
                                    onClick={buttonHandler}
                                    data-event={
                                        tracking_event_action_name
                                            ? `${tracking_event_action_name} (bubble)`
                                            : ''
                                    }
                                >
                                    <KaiScore
                                        countUpInitialValue={750}
                                        countUpMaximumValue={1000}
                                        countUpEndText="?"
                                        countDuration={3.5}
                                        countUpLoopMode={false}
                                    />
                                </button>
                            </div>
                        )}

                        <div className="GetScoreScene__content">
                            {get_score_description && (
                                <p>{parseHTML(get_score_description)}</p>
                            )}

                            {get_score_button_title && (
                                <Button
                                    variant="primary"
                                    onClick={buttonHandler}
                                    data-event={
                                        tracking_event_action_name
                                            ? `${tracking_event_action_name} (button)`
                                            : ''
                                    }
                                >
                                    {get_score_button_title}
                                </Button>
                            )}
                        </div>
                    </div>
                </Container>
            </div>
        </section>
    );
};
